import workspaceQuery from 'graphql/queries/product/LuckinsSupplierWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/product/LuckinsSupplierListQuery.graphql';
import instance from 'graphql/queries/product/LuckinsSupplierQuery.graphql';
import fragment from 'graphql/fragments/product/LuckinsSupplierFragment.graphql';
import update from 'graphql/mutations/product/LuckinsSupplierMutation.graphql';
import { ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';

const LuckinsSupplier = {
  type: 'LuckinsSupplier',
  title: 'Luckins Suppliers',
  formTitle: 'Luckins Supplier',
  workspaceUrl: '/Products/Luckins/LuckinsSupplier/Workspace/',
  formUrl: '/Products/Luckins/LuckinsSupplier/Details/',
  workspace: workspaceQuery,
  list: listQuery,
  instance,
  update,
  fragment,
  screenReference: 'LUCKINS_SUPPLIERS',
  operations: ALLOW_VIEW | ALLOW_EDIT,
};

export default LuckinsSupplier;
